import { Icon, styled } from '@mui/material'
import { 
    Step0AsStatus0Icon,
    Step0AsStatus1Icon,
    Step0AsStatus2Icon,
    Step0AsStatus3Icon,

    Step1AsStatus0Icon,
    Step1AsStatus1Icon,
    Step1AsStatus2Icon,
    Step1AsStatus3Icon,

    Step2AsStatus0Icon,
    Step2AsStatus1Icon,
    Step2AsStatus2Icon,
    Step2AsStatus3Icon,

    Step3AsStatus0Icon,
    Step3AsStatus1Icon,
    Step3AsStatus2Icon,

    Step5AsStatus0Icon,
    Step5AsStatus1Icon,
    Step5AsStatus2Icon,
    Step5AsStatus3Icon

} from '../../assets'

const StepIcon = styled(Icon)(({ theme }) => ({
    width: 64,
    height: 64,
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
        width: 48,
        height: 48
    }
}))

const Step0AsStatus0 = () => (
    <StepIcon>
        <img src={Step0AsStatus0Icon} alt="step-0-status-0" />
    </StepIcon>
)

const Step0AsStatus1 = () => (
    <StepIcon>
        <img src={Step0AsStatus1Icon} alt="step-0-status-1" />
    </StepIcon>
)

const Step0AsStatus2 = () => (
    <StepIcon>
        <img src={Step0AsStatus2Icon} alt="step-0-status-2" />
    </StepIcon>
)

const Step0AsStatus3 = () => (
    <StepIcon>
        <img src={Step0AsStatus3Icon} alt="step-0-status-3" />
    </StepIcon>
)

const Step1AsStatus0 = () => (
    <StepIcon>
        <img src={Step1AsStatus0Icon} alt="step-1-status-0" />
    </StepIcon>
)

const Step1AsStatus1 = () => (
    <StepIcon>
        <img src={Step1AsStatus1Icon} alt="step-1-status-1" />
    </StepIcon>
)

const Step1AsStatus2 = () => (
    <StepIcon>
        <img src={Step1AsStatus2Icon} alt="step-1-status-2" />
    </StepIcon>
)

const Step1AsStatus3 = () => (
    <StepIcon>
        <img src={Step1AsStatus3Icon} alt="step-1-status-3" />
    </StepIcon>
)

const Step2AsStatus0 = () => (
    <StepIcon>
        <img src={Step2AsStatus0Icon} alt="step-2-status-0" />
    </StepIcon>
)

const Step2AsStatus1 = () => (
    <StepIcon>
        <img src={Step2AsStatus1Icon} alt="step-2-status-1" />
    </StepIcon>
)

const Step2AsStatus2 = () => (
    <StepIcon>
        <img src={Step2AsStatus2Icon} alt="step-2-status-2" />
    </StepIcon>
)

const Step2AsStatus3 = () => (
    <StepIcon>
        <img src={Step2AsStatus3Icon} alt="step-2-status-3" />
    </StepIcon>
)

const Step3AsStatus0 = () => (
    <StepIcon>
        <img src={Step3AsStatus0Icon} alt="step-3-status-0" />
    </StepIcon>
)

const Step3AsStatus1 = () => (
    <StepIcon>
        <img src={Step3AsStatus1Icon} alt="step-3-status-1" />
    </StepIcon>
)

const Step3AsStatus2 = () => (
    <StepIcon>
        <img src={Step3AsStatus2Icon} alt="step-3-status-2" />
    </StepIcon>
)

const Step3AsStatus3 = () => (
    <StepIcon>
        <img src={Step5AsStatus3Icon} alt="step-3-status-3" />
    </StepIcon>
)

const Step5AsStatus0 = () => (
    <StepIcon>
        <img src={Step5AsStatus0Icon} alt="step-5-status-0" />
    </StepIcon>
)

const Step5AsStatus1 = () => (
    <StepIcon>
        <img src={Step5AsStatus1Icon} alt="step-5-status-1" />
    </StepIcon>
)

const Step5AsStatus2 = () => (
    <StepIcon>
        <img src={Step5AsStatus2Icon} alt="step-5-status-2" />
    </StepIcon>
)

const Step5AsStatus3 = () => (
    <StepIcon>
        <img src={Step5AsStatus3Icon} alt="step-5-status-3" />
    </StepIcon>
)

export {
    Step0AsStatus0,
    Step0AsStatus1,
    Step0AsStatus2,
    Step0AsStatus3,
    Step1AsStatus0,
    Step1AsStatus1,
    Step1AsStatus2,
    Step1AsStatus3,
    Step2AsStatus0,
    Step2AsStatus1,
    Step2AsStatus2,
    Step2AsStatus3,
    Step3AsStatus0,
    Step3AsStatus1,
    Step3AsStatus2,
    Step3AsStatus3,
    Step5AsStatus0,
    Step5AsStatus1,
    Step5AsStatus2,
    Step5AsStatus3
}
